/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Berufliche_Schulen_Gross_Gerau4Inputs */

const en__field_enum_berufliche_schulen_gross_gerau4 = /** @type {(inputs: _Field_Enum_Berufliche_Schulen_Gross_Gerau4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Groß-Gerau`)
};

const de__field_enum_berufliche_schulen_gross_gerau4 = /** @type {(inputs: _Field_Enum_Berufliche_Schulen_Gross_Gerau4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Berufliche Schulen Groß-Gerau`)
};

/**
* | output |
* | --- |
* | "Groß-Gerau" |
*
* @param {_Field_Enum_Berufliche_Schulen_Gross_Gerau4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_berufliche_schulen_gross_gerau4 = /** @type {((inputs?: _Field_Enum_Berufliche_Schulen_Gross_Gerau4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Berufliche_Schulen_Gross_Gerau4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_berufliche_schulen_gross_gerau4(inputs)
	return de__field_enum_berufliche_schulen_gross_gerau4(inputs)
});
export { _field_enum_berufliche_schulen_gross_gerau4 as "_field_enum_Berufliche_Schulen_Gross_Gerau" }